const DRIVER_PORTAL_HOME_PATH = "/portail";
const LOGIN_RETURN_TO_BASE_URL = "https://grain.local";

function normalizeDispatchDate(value) {
  const normalizedValue = typeof value === "string" ? value.trim() : "";
  const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(normalizedValue);
  if (!dateMatch) {
    return "";
  }

  const year = Number(dateMatch[1]);
  const month = Number(dateMatch[2]);
  const day = Number(dateMatch[3]);
  const parsedDate = new Date(Date.UTC(year, month - 1, day));

  return parsedDate.getUTCFullYear() === year
    && parsedDate.getUTCMonth() === month - 1
    && parsedDate.getUTCDate() === day
    ? normalizedValue
    : "";
}

function normalizeDispatchPeriod(value) {
  const normalizedValue = typeof value === "string" ? value.trim().toLowerCase() : "";
  return normalizedValue === "day" || normalizedValue === "evening" ? normalizedValue : "";
}

/**
 * Normalise une destination de connexion vers le portail chauffeur. Le retour
 * ne peut viser que /portail; tous les paramètres autres que la date et la
 * période de dispatch sont volontairement exclus, notamment l'aperçu admin.
 */
export function sanitizeDriverPortalLoginReturnTo(value) {
  const rawValue = typeof value === "string" ? value.trim() : "";
  if (!rawValue || !rawValue.startsWith("/") || rawValue.startsWith("//")) {
    return "";
  }

  let returnUrl;
  try {
    returnUrl = new URL(rawValue, LOGIN_RETURN_TO_BASE_URL);
  } catch {
    return "";
  }

  if (returnUrl.origin !== LOGIN_RETURN_TO_BASE_URL || returnUrl.pathname !== DRIVER_PORTAL_HOME_PATH) {
    return "";
  }

  const dispatchDate = normalizeDispatchDate(returnUrl.searchParams.get("dispatch_date"));
  const dispatchPeriod = normalizeDispatchPeriod(returnUrl.searchParams.get("dispatch_period"));
  const searchParams = new URLSearchParams();

  if (dispatchDate) {
    searchParams.set("dispatch_date", dispatchDate);
  }
  if (dispatchPeriod) {
    searchParams.set("dispatch_period", dispatchPeriod);
  }

  const search = searchParams.toString();
  return `${DRIVER_PORTAL_HOME_PATH}${search ? `?${search}` : ""}`;
}

export function readLoginNavigationRequest(search = "") {
  const searchParams = new URLSearchParams(typeof search === "string" ? search : "");

  return {
    returnTo: sanitizeDriverPortalLoginReturnTo(searchParams.get("returnTo")),
    switchAccount: searchParams.get("switchAccount") === "1",
  };
}

/**
 * La destination demandée est utilisable seulement après que les accès ont
 * identifié un compte exclusivement chauffeur. Un compte opérateur garde son
 * parcours normal, même si l'URL de connexion contient returnTo.
 */
export function resolveAuthenticatedLoginPath(entryPath, returnTo = "") {
  const sanitizedReturnTo = sanitizeDriverPortalLoginReturnTo(returnTo);
  if (entryPath !== DRIVER_PORTAL_HOME_PATH || !sanitizedReturnTo) {
    return entryPath;
  }

  return sanitizedReturnTo;
}
